export const serverDateFormat = 'YYYY-MM-DD';
export const serverTimeFormat = 'HH:mm:ss';

export const clientDateFormat = 'YYYY/MM/DD';
export const clientDateFormatFullYear = 'DD/MM/YYYY';
export const clientDateFormatShortYear = 'DD/MM/YY';
export const clientTimeFormat = 'HH:mm';

export const secondsInHour = 3600;
export const secondsInMinute = 60;
export const oneSecond = 1000;

export const serverDateTimeFormat = `${serverDateFormat} ${serverTimeFormat}`;
